// extracted by mini-css-extract-plugin
export var chevronIcon = "_be-2";
export var teamName = "_be-1";
export var teamSwitcherButton = "_be-0";